import { Component } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DepartmentsService } from '../departments.service';
import { finalize } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { NotificationService } from 'src/app/services/notification.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-add-departments',
  templateUrl: './add-departments.component.html',
  styleUrls: ['./add-departments.component.scss'],
})
export class AddDepartmentsComponent {
  errorTitle: string = environment.config.customNotifications.headers.error;
  errorIcon: string = environment.config.customNotifications.icons.error;
  errorType: string = environment.config.customNotifications.icons.error;

  token!: string;
  isLoading = false;

  // add form group in the html template

  form: FormGroup = new FormGroup({
    name: new FormControl(''),
    observatii: new FormControl(''),
  });

  constructor(
    private dialogRef: MatDialogRef<AddDepartmentsComponent>,
    private departmentsService: DepartmentsService,
    private notificationService: NotificationService,
    private authService: AuthService
  ) {
    this.processToken();
  }

  closeDialog() {
    this.dialogRef?.close({
      success: true,
    });
  }

  processToken() {
    const tokenObj = this.authService.returnTokenUser();
    tokenObj.then((token) => {
      this.token = token;
      this.departmentsService.setToken(token);
    });
  }

  submitForm() {
    this.isLoading = true;

    const departments = {
      name: this.form.get('name')?.value,
      slug: this.form.get('slug')?.value,
      observations: this.form.get('observatii')?.value,
    };

    // integrate API in addDepartment method

    // this.departmentsService.addDepartment(departments)
    //   .pipe(finalize(() => (this.isLoading = false)))
    //   .subscribe({
    //     next: (res) => {
    //       this.dialogRef.close({ success: true });
    //     },
    //     error: (err) => {
    //       let errorMessage =
    //         environment.config.customNotifications.generalMessages.error;
    //       this.notificationService.warningSwal(
    //         this.errorTitle,
    //         errorMessage,
    //         this.errorIcon
    //       );
    //     },
    //   });
  }
}
